import { createContext } from 'react';
// Context for Menu compound components
export const MenuContext = createContext(null);
